"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerHelper = void 0;
const fs_1 = require("fs");
const path_1 = require("path");
const util_1 = require("util");
// HEAVILY lifted from tslog source code
class LoggerHelper {
    static cleanUpFilePath(fileName) {
        return fileName == null
            ? fileName
            : Object.entries(fileName.split(path_1.sep))
                .reduce((cleanFileName, fileNamePart) => fileNamePart[1] !==
                LoggerHelper.cwdArray[fileNamePart[0]]
                ? (cleanFileName +=
                    path_1.sep + fileNamePart[1])
                : cleanFileName, '')
                .substring(1);
    }
    static toStackFrameObject(stackFrame) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const filePath = stackFrame.getFileName();
        return {
            filePath: (_a = LoggerHelper.cleanUpFilePath(filePath)) !== null && _a !== void 0 ? _a : '',
            fullFilePath: filePath !== null && filePath !== void 0 ? filePath : '',
            fileName: (0, path_1.basename)((_b = stackFrame.getFileName()) !== null && _b !== void 0 ? _b : ''),
            lineNumber: (_c = stackFrame.getLineNumber()) !== null && _c !== void 0 ? _c : undefined,
            columnNumber: (_d = stackFrame.getColumnNumber()) !== null && _d !== void 0 ? _d : undefined,
            isConstructor: (_e = stackFrame.isConstructor()) !== null && _e !== void 0 ? _e : undefined,
            functionName: (_f = stackFrame.getFunctionName()) !== null && _f !== void 0 ? _f : undefined,
            typeName: (_g = stackFrame.getTypeName()) !== null && _g !== void 0 ? _g : undefined,
            methodName: (_h = stackFrame.getMethodName()) !== null && _h !== void 0 ? _h : undefined,
        };
    }
    static styleString(styleTypes, str) {
        return Object.values(styleTypes).reduce((resultStr, styleType) => {
            return LoggerHelper._stylizeWithColor(styleType, resultStr);
        }, str);
    }
    static _stylizeWithColor(styleType, str) {
        var _a;
        const color = (_a = util_1.inspect.colors[styleType]) !== null && _a !== void 0 ? _a : [0, 0];
        return `\u001b[${color[0]}m${str}\u001b[${color[1]}m`;
    }
    static _getCodeFrame(filePath, lineNumber, columnNumber, linesBeforeAndAfter) {
        var _a;
        const lineNumberMinusOne = lineNumber - 1;
        try {
            const file = (_a = (0, fs_1.readFileSync)(filePath, {
                encoding: 'utf-8',
            })) === null || _a === void 0 ? void 0 : _a.split('\n');
            const startAt = lineNumberMinusOne - linesBeforeAndAfter < 0
                ? 0
                : lineNumberMinusOne - linesBeforeAndAfter;
            const endAt = lineNumberMinusOne + linesBeforeAndAfter > file.length
                ? file.length
                : lineNumberMinusOne + linesBeforeAndAfter;
            const codeFrame = {
                firstLineNumber: startAt + 1,
                lineNumber,
                columnNumber,
                linesBefore: [],
                relevantLine: '',
                linesAfter: [],
            };
            for (let i = startAt; i < lineNumberMinusOne; i++) {
                if (file[i] != null) {
                    codeFrame.linesBefore.push(file[i]);
                }
            }
            codeFrame.relevantLine = file[lineNumberMinusOne];
            for (let i = lineNumberMinusOne + 1; i <= endAt; i++) {
                if (file[i] != null) {
                    codeFrame.linesAfter.push(file[i]);
                }
            }
            return codeFrame;
        }
        catch (err) {
            // (err) is needed for Node v8 support, remove later
            // fail silently
        }
    }
    static lineNumberTo3Char(lineNumber) {
        return lineNumber < 10
            ? `00${lineNumber}`
            : lineNumber < 100
                ? `0${lineNumber}`
                : `${lineNumber}`;
    }
}
exports.LoggerHelper = LoggerHelper;
LoggerHelper.cwdArray = process.cwd().split(path_1.sep);
//# sourceMappingURL=LoggerHelper.js.map